import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '@BUP/hooks';

const questionProApiKey = process.env.REACT_APP_QUESTION_PRO_API_KEY;
const questionProUrl = process.env.REACT_APP_QUESTION_PRO_URL;

export const useGetSurveyCustomN = (surveyFiltered) => {
  // console.log('surveyFiltered', surveyFiltered)
  const { user } = useAuth();
  const { enrollmentId } = user;
  const apiKey = questionProApiKey;
  const surveyId = surveyFiltered?.surveyID;
  const urlBase = questionProUrl;

  const [listState, setListState] = useState({
    isLoading: false,
    response: [],
    error: null,
  });

  const getResponse = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      const request = await axios.get(
        `${urlBase}/surveys/${surveyId}/responses/filter?custom1=${enrollmentId}&apiKey=${apiKey}`
      );
      const data = request?.data;
      const response = data?.response ? data.response : [];
      setListState((prevState) => ({
        ...prevState,
        response,
      }));
    } catch (error) {
      console.log('useGetSurveyCustomN error or doesnt exist', error);
      setListState((prevState) => ({
        ...prevState,
        error,
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }
  }, [setListState, surveyId]);

  useEffect(() => {
    if (surveyId) getResponse();
  }, [getResponse, surveyId]);

  return {
    isLoadingCustom: listState.isLoading,
    response: listState.response,
    errorCustom: listState.error,
  };
};
